// removed by extract-text-webpack-plugin
module.exports = {"contenedor":"ZoomImagenVencimiento__contenedor___3ZXmF","imagenOriginal":"ZoomImagenVencimiento__imagenOriginal___INbZC","ventanaZoom":"ZoomImagenVencimiento__ventanaZoom___3OyIz","imagenZoom":"ZoomImagenVencimiento__imagenZoom___oXn8f"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/auditorias/revision/ZoomImagenVencimiento.css
// module id = 1056
// module chunks = 0